function unsupportedBrowser() {
  const isIE = /* @cc_on!@ */ false || !!document.documentMode

  return isIE // isIE || anotherUnsuportedBrowser
}

export default unsupportedBrowser
